import { IConfig } from '@/interface/game';
import React, { useEffect, useState } from 'react';
import CatcherGameSceneInit from './CatcherGameSceneInit';
import { loadScript } from '@/util/script';
import Game from '@/helper/games/catcher/Game';
import CatcherGameBody from './CatcherGameBody';
import { AframeListener } from '../../js/aframeListener';
import { renderARElements } from '@/helper/ar';
import CatcherGameInst from './CatcherGameIns';

const scripts = [
  {
    uri: 'https://s3.ap-south-1.amazonaws.com/vizaro.in/app/lib/aframe.min.js',
  },

  {
    uri: 'https://s3.ap-south-1.amazonaws.com/vizaro.in/app/lib/aframe-physics-system.min.js',
  },
  {
    uri: 'https://cdn.jsdelivr.net/gh/c-frame/aframe-extras@7.4.0/dist/aframe-extras.min.js',
  },
];

const defaultAssets = [
  {
    type: 'OBJECT',
    sub_type: 'OBJECT_1',
    uri: 'https://cdn-icons-png.flaticon.com/512/3142/3142740.png',
  },
  {
    type: 'OBJECT',
    sub_type: 'OBJECT_2',
    uri: 'https://s3.ap-south-1.amazonaws.com/vizaro.in/dump/ar-1.png',
  },
  {
    type: 'OBJECT',
    sub_type: 'OBJECT_2',
    uri: 'https://s3.ap-south-1.amazonaws.com/vizaro.in/dump/ar-2.png',
  },
];
type CatcherGameContentProps = {
  config?: IConfig;
};

const CatcherGameContent = ({ config }: CatcherGameContentProps) => {
  const [isScriptLoaded, setScriptLoaded] = useState(false);
  const [isAframeListenerLoaded, setIsAframeListenerLoaded] = useState(false);
  const [isInst, setIsInst] = useState(false);

  const renderElements = () => {
    let elements = config?.elements || [];

    elements = elements.filter(ele => ele.type !== 'OBJECT');
    renderARElements(elements, undefined, 'CATCHER');
  };
  const onGameInit = () => {
    const assets = config?.elements || defaultAssets;
    const collectAsset = assets.find(ele => ele.sub_type == 'OBJECT_2');
    const collectibleAssets =
      assets.filter(ele => ele.sub_type == 'OBJECT_1') || [];
    const game = new Game(collectibleAssets, collectAsset, config?.timer || 60);
    game.gameStart();
  };
  const onSceneLoad = () => {
    setIsInst(true);
    setTimeout(() => {
      renderElements();
      setIsInst(false);
      onGameInit();
    }, 3000);
  };
  const onLoadScripts = async () => {
    for (const script of scripts) {
      await loadScript(script.uri);
    }
    setScriptLoaded(true);
  };
  useEffect(() => {
    onLoadScripts();
  }, []);
  useEffect(() => {
    if (!isScriptLoaded) return;
    if (isAframeListenerLoaded) {
      const scene: any = document.querySelector('a-scene');
      if (scene && scene.hasLoaded) {
        onSceneLoad();
      } else if (scene) {
        scene.addEventListener('loaded', onSceneLoad);
      }
    }
    if (!isAframeListenerLoaded) {
      new AframeListener();
      setIsAframeListenerLoaded(true);
    }
  }, [isAframeListenerLoaded, isScriptLoaded]);

  if (!isAframeListenerLoaded) return <div>Loading AR experience...</div>;
  return (
    <div className="" id="markerless">
      {isInst && <CatcherGameInst />}
      <CatcherGameBody />
      <CatcherGameSceneInit />
    </div>
  );
};

export default CatcherGameContent;
